import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';
import { toDateString } from '../../../utils/date';

function OtherImageryPreview({
  date,
  layer,
  handleRightClick,
  handleLeftClick,
  locale = 'en-US',
}) {
  return (
    <PreviewNavigationCard
      onLeftClick={handleLeftClick}
      onRightClick={handleRightClick}
    >
      <span>{`${toDateString(date, locale)} ${getMessage(
        `card.${layer}`
      )}`}</span>
    </PreviewNavigationCard>
  );
}

OtherImageryPreview.propTypes = {
  date: PropTypes.string.isRequired,
  handleLeftClick: PropTypes.func.isRequired,
  handleRightClick: PropTypes.func.isRequired,
  layer: PropTypes.string.isRequired,
  locale: PropTypes.string,
};

export default OtherImageryPreview;
